import { Component } from '@angular/core';

@Component({
  selector: 'app-playground-process',
  standalone: true,
  imports: [],
  templateUrl: './playground-process.component.html',
  styleUrl: './playground-process.component.scss'
})
export class PlaygroundProcessComponent {

}
